module.exports = __webpack_public_path__ + "static/media/flashlight.e923518f.svg";